module.exports = __webpack_public_path__ + "static/media/designPatent_30-0992957.8536e43a.png";